<template>
  <div class="wrapper">
    <div class="top">
      <!-- {{$i18n.locale}}
      <div @click="playVideo">点击我播放</div>
      <youtube video-id="CJ0xx9hJua4" ref="youtube" @playing="playing"></youtube> -->
      <router-link to="/">
        <div class="logo">
          <img src="@/assets/images/sld.jpg" alt>
        </div>
      </router-link>
      <!-- <div class="welecome">{{$t('welecome')}}</div> -->
    </div>
    <div class="m">
      <div class="container">
        <div class="login-form-wrap">
          <div class="login-form">
            <div class="tabs" v-if="$i18n.locale == 'zh'">
              <div class="tab" :class="{active:loginType==0}" @click="loginType=0" v-if="!user_wx_id">{{$t('accountLogin')}}</div>
              <div class="tab" :class="{active:loginType==1}" @click="loginType=1" v-if="!user_wx_id">{{$t('verificationCodeLogin')}}</div>
              <div class="tab active" v-if="user_wx_id">绑定手机号</div>
            </div>
            <div v-show="loginType==0 && !user_wx_id">
              <input-group icon="icontel" :placeholder="$t('pMobileorAccount')" v-model="telphone"></input-group>
              <input-group
                icon="iconpassword"
                :placeholder="$t('pEnterPwd')"
                v-model="password"
                :type="showPassword?'text':'password'"
                @keyup.enter.native="loginAjax"
              >
                <i
                  class="icon iconfont"
                  :class="showPassword?'iconpassword-view':' iconpassword-not-view'"
                  @click="changeInputType"
                ></i>
              </input-group>
              <div class="login-item" v-if="isCaptcha">
                <input-group class="login-item-input" placeholder-class="login-item-i-p fsz26" type="text" v-model="captcha" placeholder="输入验证码" style="width: 100%" ></input-group>
                <img class="codeimg" :src="captchaUrl" alt="" @click="getCodeImg" />
              </div>
            </div>
            <div v-show="loginType==1 || user_wx_id">
              <code-input
                @getTelPhone="getPhoneValue"
                @getInputError="getInputError"
                @getSmsCode="getSmsCode"
              ></code-input>
            </div>
            <div class="error" v-show="showError">
              <i class="icon iconfont iconerror"></i>
              {{errorText}}
            </div>
            <div class="login-btn" @click="loginAjax">{{ user_wx_id ? '绑定手机号' : $t('login') }}</div>
            <div class="wechat-login-wrap" v-if="showWechatLogin && !user_wx_id" style="text-align: center; margin-top: 20px;">
              <el-tooltip class="item" effect="dark" content="微信扫码登录" placement="bottom">
                <i class="icon iconfont iconweixin" style="font-size: 36px; color: #07C160; cursor: pointer; transition: all 0.3s;" @click="openWechatLogin"></i>
              </el-tooltip>
            </div>
            <div class="tip">
              <router-link to="register">{{$t('register')}}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 微信扫码登录弹窗 -->
    <el-dialog
      :visible.sync="wechatDialogVisible"
      width="360px"
      center
      custom-class="wechat-qr-dialog"
      @close="closeWechatLogin"
    >
      <div v-if="wechatDialogVisible" style="text-align: center; display: flex; justify-content: center; align-items: center; min-height: 300px;">
        <div id="wx-qrcode" ref="wxQrcode"></div>
      </div>
    </el-dialog>
    
    <CopyRight></CopyRight>
  </div>
</template>

<script>
import LoginInputGroup from "@/components/login/LoginInputGroup.vue";
import InputGroup from "@/components/layout/InputGroup.vue";
import CopyRight from "@/components/common/CopyRight.vue";
import { inputCheckPhone, isValid } from "@/utils/index.js";
import { mapActions } from "vuex";
import { apiBaseUrl, showWechatLogin } from '@/config/env.js'
import QRCode from 'qrcodejs2';

export default {
  name: "Login",
  components: {
    "code-input": LoginInputGroup,
    "input-group": InputGroup,
    CopyRight
  },
  props: {},
  data() {
    return {
      telphone: "",
      password: "",
      smsCode: "",
      checked: true,
      loginType: 0,
      errorText: "",
      showPassword: false,
      isCaptcha: false, // 是否需要验证码
      captcha: '', // 输入的验证码
      captchaUrl: '', // 验证码图片地址
      wechatDialogVisible: false, // 微信扫码弹窗
      pcLoginSessionId: '', // 扫码登录的会话ID
      checkLoginTimer: null, // 轮询定时器
      showWechatLogin: showWechatLogin, // 是否显示微信扫码登录入口
      user_wx_id: "", // 微信扫码返回的 user_wx_id，存在则表示需要绑定手机号
    };
  },
  watch: {},
  computed: {
    showError() {
      return isValid(this.errorText);
    },
    player() {
      return this.$refs.youtube.player
    }
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    playing() {
      this.$refs.youtube.player.playVideo()
    },
    playVideo() {
      this.player.playVideo()
    },
    loginAjax() {
      if (this.loginType == 0) {
        this.passwordToLogin();
      } else {
        this.smsCodeLogin();
      }
    },
    changeInputType() {
      this.showPassword = !this.showPassword;
    },
    checkInputPhone() {
      if (!isValid(this.telphone)) {
        this.errorText = this.$t('mobileorAccountNo');
        return false;
      } 
      this.errorText = "";
      return true;
    },
    checkInputPassword() {
      if (!isValid(this.password)) {
        this.errorText = this.$t('pEnterPwd');
        return false;
      }
      return true;
    },
    checkInputCode() {
      if (!isValid(this.smsCode)) {
        this.errorText = this.$t('pEvalidation');
        return false;
      }
      return true;
    },
    smsCodeLogin() {
      if (this.checkInputPhone() && this.checkInputCode()) {
        let data = {
          mobile: this.telphone,
          code: this.smsCode,
          platform: 5
        };

        if(localStorage.getItem('invite')) {
          data.invitecode = localStorage.getItem('invite')
        }
        if (this.user_wx_id) {
          data.user_wx_id = this.user_wx_id;
        }
        let _this = this;
        this.$api.smsLogin(data).then(res => {
          if (res.status) {
            _this.$storage.set("timer", 0);
            _this.$storage.set("userToken", res.data);
            _this.$api.userInfo({}).then(result => {
              if (result.status) {
                _this.getUserInfo(result.data);
                _this.$storage.set("userInfo", result.data);
              }
            });

            // _this.$api.shareCode({}).then(res => {
            //   if(res.status) {
            //     localStorage.setItem('invite', res.data)
            //   }
            // })


            _this.$router.go(-1);
            setTimeout(() => {
              if (_this.$route.path === '/login') {
                _this.$router.replace("/");
              }
            }, 300);
          } else {
            _this.errorText = res.msg;
          }
        });
      }
    },
    passwordToLogin() {
      if (this.checkInputPhone() && this.checkInputPassword()) {
        let data={
          mobile:this.telphone,
          password:this.password,
          platform:5
        }
        if(this.isCaptcha){
          data.captcha=this.captcha
        }

        if(localStorage.getItem('invite')) {
          data.invitecode = localStorage.getItem('invite')
        }
        let _this = this;
        this.$api.login(data).then(res => {
          if (res.status) {
            _this.$storage.set("userToken", res.data);
            _this.$api.userInfo({}).then(result => {
              if (result.status) {
                _this.getUserInfo(result.data);
                _this.$storage.set("userInfo", result.data);
              }
            });

            // _this.$api.shareCode({}).then(res => {
            //   if(res.status) {
            //     localStorage.setItem('invite', res.data)
            //   }
            // })


            // _this.$router.push("home");
            _this.$router.go(-1);
            setTimeout(() => {
              if (_this.$route.path === '/login') {
                _this.$router.replace("/");
              }
            }, 300);
          } else {
            _this.errorText = res.msg;
            // 需要输入验证码 或者 验证码错误刷新
            if (res.data === 10013 || res.data === 10012) {
              _this.isCaptcha = true
            }
            // 登录需要验证码
            if (_this.isCaptcha) {
              _this.getCaptchaUrl()
            }
          }
        });
      }
    },
      // 获取验证码图片地址
    getCaptchaUrl() {
      this.captchaUrl = apiBaseUrl + 'captcha.html'
    },
    getCodeImg() {
      let num = Math.ceil(Math.random() * 1000)
      this.captchaUrl = apiBaseUrl + 'captcha.html?' + num
    },
    //获取子组件手机号
    getPhoneValue(val) {
      this.telphone = val;
    },
    //获取子组件验证码
    getSmsCode(val) {
      this.smsCode = val;
    },
    //获取错位信息
    getInputError(val) {
      this.errorText = val;
    },
    // 打开微信扫码登录
    openWechatLogin() {
      this.wechatDialogVisible = true;
      if (!window.WxLogin) {
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';
        document.body.appendChild(script);
        script.onload = () => {
          this.renderWxLogin();
        };
      } else {
        this.renderWxLogin();
      }
    },
    // 渲染微信扫码登录
    renderWxLogin() {
      this.$nextTick(() => {
        this.$api.post('user.getpcloginqrcode', {}).then(res => {
          if (res.status) {
            this.pcLoginSessionId = res.data.session_id;
            this.$refs.wxQrcode.innerHTML = '';
            new window.WxLogin({
              self_redirect: true,
              id: "wx-qrcode",
              appid: res.data.appid,
              scope: "snsapi_login",
              redirect_uri: res.data.redirect_uri,
              state: res.data.session_id,
              style: "black",
              href: ""
            });
            // 开启轮询 (作为双保险)
            this.startCheckLogin();
          } else {
            this.$message.error(res.msg || '获取扫码参数失败');
          }
        });
      });
    },
    // 关闭微信扫码登录
    closeWechatLogin() {
      this.wechatDialogVisible = false;
      if (this.checkLoginTimer) {
        clearInterval(this.checkLoginTimer);
        this.checkLoginTimer = null;
      }
    },
    // 轮询检查扫码登录状态
    startCheckLogin() {
      if (this.checkLoginTimer) {
        clearInterval(this.checkLoginTimer);
      }
      this.checkLoginTimer = setInterval(() => {
        if (!this.wechatDialogVisible || !this.pcLoginSessionId) {
          clearInterval(this.checkLoginTimer);
          return;
        }
        this.$api.post('user.checkpclogin', { session_id: this.pcLoginSessionId }).then(res => {
          if (res.status && res.data) {
            clearInterval(this.checkLoginTimer);
            this.wechatDialogVisible = false;
            if (this.$storage.get("userToken")) {
              return;
            }
            
            let resultData = res.data;
            if (resultData && resultData.user_wx_id) {
              if (this.user_wx_id) {
                return;
              }
              // 未绑定手机号时，弹出 Element UI 确认弹窗
              this.$confirm('您的微信尚未绑定手机号，请先绑定手机号后登录', '提示', {
                confirmButtonText: '去绑定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
              }).then(() => {
                this.user_wx_id = resultData.user_wx_id;
                this.loginType = 1;
              }).catch(() => {
                // Cancelled
              });
            } else if (resultData && resultData.token) {
              // 登录成功
              this.$storage.set("timer", 0);
              this.$storage.set("userToken", resultData.token);
              this.$api.userInfo({}).then(infoRes => {
                if (infoRes.status) {
                  this.getUserInfo(infoRes.data);
                  this.$storage.set("userInfo", infoRes.data);
                }
              });
              this.$message.success('登录成功');
              this.$router.go(-1);
              setTimeout(() => {
                if (this.$route.path === '/login') {
                  this.$router.replace("/");
                }
              }, 300);
            }
          }
        });
      }, 2000);
    },
    // 监听微信授权成功后的 postMessage 消息
    handleWechatMessage(e) {
      if (e.data && typeof e.data === 'object' && e.data.hasOwnProperty('status')) {
        let res = e.data;
        if (res.status && res.data) {
          if (this.checkLoginTimer) {
            clearInterval(this.checkLoginTimer);
            this.checkLoginTimer = null;
          }
          this.wechatDialogVisible = false;
          if (this.$storage.get("userToken")) {
            return;
          }
          let resultData = res.data;
          if (resultData && resultData.user_wx_id) {
            if (this.user_wx_id) {
              return;
            }
            this.$confirm('您的微信尚未绑定手机号，请先绑定手机号后登录', '提示', {
              confirmButtonText: '去绑定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }).then(() => {
              this.user_wx_id = resultData.user_wx_id;
              this.loginType = 1;
            }).catch(() => {
              // Cancelled
            });
          } else if (resultData && resultData.token) {
            this.$storage.set("timer", 0);
            this.$storage.set("userToken", resultData.token);
            this.$api.userInfo({}).then(infoRes => {
              if (infoRes.status) {
                this.getUserInfo(infoRes.data);
                this.$storage.set("userInfo", infoRes.data);
              }
            });
            this.$message.success('登录成功');
            this.$router.go(-1);
            setTimeout(() => {
              if (this.$route.path === '/login') {
                this.$router.replace("/");
              }
            }, 300);
          }
        } else if (res.status === false && res.msg) {
          if (this.checkLoginTimer) {
            clearInterval(this.checkLoginTimer);
            this.checkLoginTimer = null;
          }
          this.wechatDialogVisible = false;
          if (this.$storage.get("userToken") || this.user_wx_id) {
            return;
          }
          this.$message.error(res.msg);
        }
      }
    }
  },
  created() {},
  mounted() {
    window.addEventListener('message', this.handleWechatMessage);
    if (this.$route.query.user_wx_id) {
      if (this.user_wx_id || this.$storage.get("userToken")) {
        return;
      }
      this.$confirm('您的微信尚未绑定手机号，请先绑定手机号后登录', '提示', {
        confirmButtonText: '去绑定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.user_wx_id = this.$route.query.user_wx_id;
        this.loginType = 1;
      }).catch(() => {
        // Cancelled
      });
    }
    if (this.$storage.get("userToken")) {
      this.$router.replace("/");
    }
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleWechatMessage);
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.wrapper {
  width: 100%;
  height: 100%;
  background: #fff;
  .top {
    height: 100px;
    background: #fff;
    position: relative;
    .logo {
      width: 200px;
      height: 60px;
      position: absolute;
      top: 40px;
      left: 200px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .welecome {
      width: 100px;
      height: 40px;
      line-height: 40px;
      position: absolute;
      top: 50px;
      left: 420px;
      font-size: 20px;
    }
  }
  .m {
    width: 100%;
    height: 480px;
    // background: url(https://image.suning.cn/uimg/cms/img/155478967914292277.jpg)
    //   no-repeat center;
    background: url('~@/assets/images/home/login-bg.jpg') no-repeat;
    background-size: cover; 
    // background: $theme-bg;
    .container {
      width: 1226px;
      height: 100%;
      position: relative;
      margin: 0 auto;
      .login-form-wrap {
        position: absolute;
        right: 0;
        top: 50%;
        width: 320px;
        height: 410px;
        margin-top: -205px;
        background: #fff;
        padding: 23px;
        box-sizing: border-box;
        .login-form {
          position: relative;
          height: 100%;
          .tabs {
            margin: 20px auto;
            display: flex;
            justify-content: space-around;
            .tab {
              text-align: center;
              flex: 1;
              cursor: pointer;
              &:first-of-type {
                border-right: 1px solid #373131;
              }
              &.active {
                color: $theme-color;
              }
            }
          }
          .error {
            font-size: 12px;
            color: $theme-color;
            transition: all 0.2s;
          }
          .login-btn {
            width: 100%;
            height: 40px;
            line-height: 40px;
            background: $theme-color;
            color: #fff;
            font-size: 12px;
            text-align: center;
            cursor: pointer;
            margin-top: 20px;
          }
          .tip {
            text-align: right;
            margin: 5px 0 60px;
            a {
              display: inline-block;
              color: #666666;
              padding: 0 6px;
              font-size: 10px;
              &:not(:last-of-type) {
                border-right: 1px solid #e0e0e0;
              }
              &:hover {
                color: $theme-color;
              }
            }
          }
          .fast {
            position: absolute;
            width: 100%;
            bottom: 15px;
            left: 0;
            .intro {
              text-align: center;
              width: 50px;
              height: 20px;
              margin: 0 auto 20px;
              font-size: 12px;
              line-height: 20px;
              position: relative;
              &:before {
                content: "";
                position: absolute;
                left: -50px;
                top: 9px;
                width: 40px;
                height: 1px;
                background: #ccc;
              }
              &:after {
                content: "";
                position: absolute;
                right: -50px;
                top: 9px;
                width: 40px;
                height: 1px;
                background: #ccc;
              }
            }
            .login-type {
              display: flex;
              justify-content: center;
              .type-item {
                width: 24px;
                height: 24px;
                border-radius: 50%;
                padding: 4px;
                cursor: pointer;
                margin: 0 20px;
                .icon {
                  font-size: 24px;
                }
                .iconqq,
                .iconzhifubao {
                  color: #1296db;
                }
                .iconweixin {
                  color: #1afa29;
                }
              }
            }
          }
        }
      }
    }
  }
}
.copyright-wrap {
  background: $theme-bg;
}
.login-item{
  position: relative;
}
.codeimg{
  width: 100%;
  height: 38px;
  position: absolute;
  top: 1px;
  right: 1px;
  width: 150px;
}
</style>
<style lang="scss">
/* 专门针对微信扫码弹窗做样式覆盖，去除多余空白 */
.wechat-qr-dialog .el-dialog__header {
  padding: 0px 20px 0 !important;
}
.wechat-qr-dialog .el-dialog__title {
  display: none !important;
}
.wechat-qr-dialog .el-dialog__body {
  padding: 10px 20px 20px 20px !important;
}
</style>